export interface SubscriptionType {
	key: string;
	label: string;
}

export const SUBSCRIPTION_PLANS: SubscriptionType[] =
[
	{
		'key': 'lite',
		label: 'Lite',
	},

	{
		key: 'essential',
		label: 'Essential',
	},

];


export const SUBSCRIPTION_TYPES: SubscriptionType[] =
	[

		{
			key: 'trial',
			label: 'Trial',
		},

		{
			key: 'paying',
			label: 'Paying',
		},

		{
			key: 'internal',
			label: 'Internal',
		},

		{
			key: 'student',
			label: 'Student',
		}

	];
